<template>
  <v-container>
    <v-layout>
      <h3>Camping</h3>
      <v-flex class="text-xs-right">${{ campsiteTotals.retail.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-layout>
      <h3>Parking</h3>
      <v-flex class="text-xs-right">${{ parkingTotals.retail.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-layout>
      <h3>GatePasses</h3>
      <v-flex class="text-xs-right">${{ gatePassTotals.retail.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-layout
      v-if="assertSetting('personReserve', 1)"
      align-center
      justify-space-between
    >
      <h3>Reservation Discount</h3>
      <v-flex
        class="pa-0"
        xs2
      >
        <v-text-field
          v-model="workingInvoice.discount"
          :rules="[discountValidation]"
          prefix="%"
          mask="###"
          reverse
          class="ma-0"
          @change="updateInvoice()"
        />
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout>
      <h3>Subtotal</h3>
      <v-flex class="text-xs-right">${{ subTotal.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-layout
      align-center
      justify-space-between
    >
      <h3>
        Other Charges
      </h3>
      <v-flex class="text-xs-right">${{ otherChargeTotal.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-layout class="pb-3">
      <h3>Grand Total</h3>
      <v-flex class="text-xs-right">${{ grandTotal.toFixed(2) }}</v-flex>
    </v-layout>
    <v-divider/>
    <v-select
      v-if="assertSetting('personReserve', 1)"
      v-model="workingInvoice.invoiceSourceID"
      :items="invoiceSources"
      label="Source"
      @input="updateInvoice()"
    />
    <v-select
      v-if="person.commercialPermitID"
      v-model="workingInvoice.commercialPermit"
      :items="[{text: 'No', value: false}, {text: 'Yes', value: true}]"
      label="Commercial Use?"
      @input="updateInvoice()"
    />
    <v-textarea
      v-if="assertSetting('personReserve', 1)"
      v-model="workingInvoice.note"
      label="Note"
      outline
      @change="updateInvoice()"
    />
    <v-layout>
      <v-btn :to="{path: '/checkout/terms'}">Continue Checkout</v-btn>
      <v-btn
        v-if="assertSetting('personReserve', 1)"
        @click="workingInvoice.held = Number(!Boolean(Number(workingInvoice.held))); updateInvoice()"
      >
        <template v-if="Boolean(Number(workingInvoice.held))">
          Remove Hold
        </template>
        <template v-else>
          Hold
        </template>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import checkoutMixin from '@/mixins/checkout'
import { mapActions } from 'vuex'
export default {
  mixins: [
    checkoutMixin.totals
  ],
  data () {
    return {
      discountValidation: value => value <= 100 || 'over 100%',
      invoiceSources: [
        'Internet',
        'Mail',
        'Phone',
        'Radio',
        'Counter',
        'Togue Pond',
        'Matagamon'
      ],
      invoiceSourceID: 'Internet'
    }
  },
  mounted () {
    this.getWorkingInvoice().then(() => {
      this.discount = this.workingInvoice.discount
    })
  },
  methods: {
    ...mapActions({
      $updateInvoice: 'invoices/updateInvoice',
      getWorkingInvoice: 'invoices/getWorkingInvoice'
    }),
    updateInvoice () {
      if (this.workingInvoice.discount === '') {
        this.workingInvoice.discount = 0
      } else if (this.workingInvoice.discount > 100) {
        this.workingInvoice.discount = 100
      }
      this.$updateInvoice(this.workingInvoice)
    }
  }
}
</script>
